import { render, staticRenderFns } from "./TempatTidur.vue?vue&type=template&id=337e2020"
import script from "./TempatTidur.vue?vue&type=script&lang=js"
export * from "./TempatTidur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports